import React, { useEffect, useState } from 'react';
import "../../../../Assets/Css/ViewDocument.scss"
import { useLocation, useNavigate } from 'react-router-dom';

const ViewEmpNotes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data?.allData;
    const [fileUrl, setFileUrl] = useState(null);

    useEffect(() => {
        if (data?.file?.data && data?.file?.type === 'Buffer') {
            const byteArray = new Uint8Array(data.file.data);
            const stringData = new TextDecoder().decode(byteArray);

            let base64String = '';
            let mimeType = '';

            if (stringData.startsWith('data:')) {
                const match = stringData.match(/^data:(.*?);base64,(.*)$/);
                if (match) {
                    mimeType = match[1];
                    base64String = match[2];
                }
            } else {
                mimeType = 'application/pdf';
                base64String = btoa(String.fromCharCode(...byteArray));
            }

            try {
                const binaryString = atob(base64String);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                const blob = new Blob([bytes], { type: mimeType });
                const url = URL.createObjectURL(blob);
                setFileUrl(url);

                return () => URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Error decoding base64 or creating blob:', error);
            }
        }
    }, [data]);


    return (
        <>
            {location?.pathname === "/project/employeeproject/view/files/view" ? (
                    <div className='preview-container'>
                        <div className="page-title">
                            <h4> View Document</h4>
                            <div className="edit-btn">
                                <button
                                    type="submit"
                                    className="custom-btn"
                                    onClick={() => navigate(-1)}
                                >Cancel</button>
                            </div>
                        </div>

                        <div className='pdf-container'>
                            {fileUrl ? (
                                <iframe
                                    src={fileUrl}
                                    width="100%"
                                    height="100%"
                                    title="Sample PDF"
                                    className='frame-pdf'
                                ></iframe>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
            ) : (

                <div className='preview-container'>
                    <div className="page-title">
                        <h4> View Document</h4>
                        <div className="edit-btn">
                            <button
                                type="submit"
                                className="custom-btn"
                                onClick={() => navigate(-1)}
                            >Cancel</button>
                        </div>
                    </div>

                    <div className='pdf-container'>
                        {fileUrl ? (
                            <iframe
                                src={fileUrl}
                                width="100%"
                                height="100%"
                                title="Sample PDF"
                                className='frame-pdf'
                            ></iframe>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ViewEmpNotes;